import type * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Campo comum: fundo `--input`, borda `--border`, raio `--radius-md`.
 * No foco: `--border-strong` + `--focus-ring`.
 *
 * O `--input-recuo` é uma sombra INTERNA: dá ao campo a leitura de sulco na superfície, em vez de
 * bloco sobre ela. É o que separa uma tela de formulário densa de uma grade de caixas.
 *
 * `ComponentProps<'input'>` em vez de `InputHTMLAttributes`: no React 19 o `ref` é
 * uma prop comum, mas só entra no tipo por esta via.
 */
export function Input({ className, ...p }: React.ComponentProps<'input'>) {
  return (
    <input
      className={cn(
        'flex h-10 w-full rounded-md border border-border bg-input px-3 py-2',
        'shadow-[var(--input-recuo)]',
        'text-[15px] text-text placeholder:text-text-tertiary',
        'transition-colors duration-[var(--dur-fast)] ease-[var(--ease)]',
        'focus-visible:outline-none focus-visible:border-accent focus-visible:shadow-[var(--focus-ring)]',
        'disabled:cursor-not-allowed disabled:opacity-45',
        // Erro: borda `--danger` (aplicado por quem usa, via aria-invalid)
        'aria-[invalid=true]:border-danger',
        className,
      )}
      {...p}
    />
  );
}
